// extracted by mini-css-extract-plugin
export var active = "_2k-2";
export var highlight = "_2k-1";
export var highlightLayer = "_2k-0";
export var issuePopover = "_2k-3";
export var statusIcon = "_2k-4";